/**
 * Pure derivation of the welcome overlay's display mode. No I/O, no framework imports — the inputs
 * are gathered by the host layer and passed in, matching the ptt-state / mic-availability convention.
 */

export type WelcomeMode = 'welcome-teach' | 'welcome-cta' | 'degraded';

/**
 * Welcome overlay mode: a transport failure is terminal and beats the audio states.
 */
export function deriveWelcomeMode(transportFailed: boolean, audioBlocked: boolean): WelcomeMode {
  if (transportFailed) {
    return 'degraded';
  }
  return audioBlocked ? 'welcome-cta' : 'welcome-teach';
}
